import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { IToastConfig } from '../interfaces/toast-config.interfaces';

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  private readonly toastSubject = new BehaviorSubject<IToastConfig | null>(null);
  public toast$ = this.toastSubject.asObservable();

  showToast(toast: IToastConfig): void {
    this.toastSubject.next(toast);
  }

  hideToast(): void {
    this.toastSubject.next(null);
  }
}
